exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".classReviewsContent .detailsViewPrompt{font-weight:700}.classReviewsContent .skillsetBanner{margin-top:40px;margin-bottom:30px}.classReviewsContent .ratingContainer{margin-bottom:15px}.classReviewsContent .bookReview{margin-bottom:20px}.classReviewsContent .bookReview .reviewText{overflow:hidden}.classReviewsContent .bookReview.borderedReview{border-bottom:1px solid #ddd;padding-bottom:20px}.classReviewsContent .bookReview .reviewStudentName{text-align:right}.classReviewsContent .bookReview .reviewStudentName .owlConstraints{float:right;position:relative;bottom:5px;margin-left:5px}.reviewsContent .detailsViewPrompt{font-weight:700;margin-bottom:0}.reviewsContent .removeReview,.reviewsContent .reviseReview{font-size:.8em;display:inline-block}.reviewsContent .verticalDivider{border-color:#ddd;height:20px;margin-left:5px;margin-right:5px}.myShelfPage .reviewsContent .reviewLink{position:relative;font-size:.8em;float:right;bottom:10px;z-index:1}.myShelfPage .reviewsContent .draftReview{opacity:.5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/reading/shelves/reviews_display.scss
// module id = 1376
// module chunks = 0